module.exports = __webpack_public_path__ + "static/media/write_statement.427d98e7.svg";